import { DecimalCategoryFilter, GenericStringValueIdCategoryFilter, StringCategoryFilter, StringValueIdCategoryFilter } from './filter-backend';
import { PageModel } from './page.model';
import { ProductCategoryFilter } from './product-category-filter.model';

export class WheelCategoryFilter implements ProductCategoryFilter {
  paging: PageModel;

  aggressive: boolean;
  blem: boolean;
  bore: DecimalCategoryFilter;
  category: StringValueIdCategoryFilter;
  directFit: boolean;
  finish: StringValueIdCategoryFilter;
  hubcentric: boolean;
  maxOffset: number;
  maxWeight: number;
  minOffset: number;
  minWeight: number;
  offset: DecimalCategoryFilter;
  pcd: GenericStringValueIdCategoryFilter;
  productStatus: StringCategoryFilter;
  stance: DecimalCategoryFilter;
  style: StringCategoryFilter;
  wheelBrand: StringCategoryFilter;
  wheelDiameter: GenericStringValueIdCategoryFilter;
  wheelDiameterRear: DecimalCategoryFilter;
  wheelFinish: StringValueIdCategoryFilter;
  wheelWidth: GenericStringValueIdCategoryFilter;
  wheelWidthRear: DecimalCategoryFilter;
  archive: boolean;
}
